module.exports = __webpack_public_path__ + "static/media/Brands_16.ac553330.png";